import axios from "axios";
import { EditProjectContextProps } from "../../EditProjectContext";
import { LtlPipelineViewModel } from "../../../ViewModel/LtlPipelineViewModel";
import { combinedUrls } from "../../../../URL/functions";
import { projectUrls } from "../../../../URL/ApplicationUrls";

export async function getAllActiveLtlRoutings(
  editProjectContext: EditProjectContextProps,
  spdrIds: (number | undefined)[] | undefined,
  pdsrIds: (number | undefined)[] | undefined
) {
  const { project } = editProjectContext;

  const url = combinedUrls(
    projectUrls.projectWithId(project.ProjectId).apiUrl,
    "/AllActiveLtlRouting"
  );

  const data = {
    LtlSpdrIds: spdrIds,
    LtlPdsrIds: pdsrIds,
  };

  const response = await axios.post(url, data);
  if (response.status !== 200) {
    throw new Error("Network response was not ok");
  }

  return response.data as Array<LtlPipelineViewModel>;
}
